/* src/app/oversign-time/oversign-time-feature/oversign-time-feature.component.scss */
/*# sourceMappingURL=oversign-time-feature.component.css.map */
